module.exports = __webpack_public_path__ + "static/img/news-date-style.ab626a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/news-date-style.png
// module id = QyNp
// module chunks = 1